import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import './assets/css/style.css'

Vue.config.productionTip = false

// 配置 axios 基础路径
// axios.defaults.baseURL = 'http://localhost:8089'
axios.defaults.baseURL = '/api'

// 配置 axios 请求拦截器，自动添加 token
axios.interceptors.request.use(
  config => {
    // 从 localStorage 中获取 token
    const token = localStorage.getItem('token')
    if (token) {
      // 在请求头中添加 Authorization
      config.headers['Authorization'] = token
      console.log('请求携带token:', token)
    } else {
      console.warn('未找到token, 将以游客身份访问')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 配置 axios 响应拦截器，处理 401 未授权
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      // token 失效或验证失败，清除本地存储并跳转到登录页
      alert('登录已过期，请重新登录')
      localStorage.clear()
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
